(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wbi-cart-upsell"] && !Shopify.designMode) return;
  try {
    ;(() => {
  if (window.wbiCuInit) return;
  window.wbiCuInit = true;

  const TAG = 'wbi-cart-upsell';
  const ADDED_MS = 1600;
  const SWIPE_MIN = 35;

  const cartAddUrl = () => `${window.Shopify?.routes?.root || '/'}cart/add.js`;

  const cartSectionIds = () => {
    const ids = [];
    for (const node of document.querySelectorAll('cart-items-component[data-section-id]')) {
      const id = node.dataset.sectionId;
      if (id && !ids.includes(id)) ids.push(id);
    }
    return ids;
  };

  const announce = (host, message) => {
    const region = host.querySelector('[data-wbi-cu-live]');
    if (region && message) {
      region.textContent = '';
      region.textContent = message;
    }
  };

  const slides = (host) => host.querySelectorAll('.wbi-cu__slide');

  function goTo(host, index) {
    const track = host.querySelector('.wbi-cu__track');
    const all = slides(host);
    if (!track || !all.length) return;

    const cursor = Math.max(0, Math.min(index, all.length - 1));
    host.dataset.wbiCuCursor = cursor;

    const rtl = getComputedStyle(host).direction === 'rtl';
    track.style.transform = `translateX(${cursor * (rtl ? 100 : -100)}%)`;

    const prev = host.querySelector('[data-wbi-cu-prev]');
    const next = host.querySelector('[data-wbi-cu-next]');
    if (prev) prev.disabled = cursor === 0;
    if (next) next.disabled = cursor >= all.length - 1;
  }

  const cursorOf = (host) => Number(host.dataset.wbiCuCursor) || 0;

  function onVariantChange(select) {
    const item = select.closest('.wbi-cu__slide');
    const option = select.selectedOptions[0];
    if (!item || !option) return;

    const price = item.querySelector('[data-wbi-cu-price]');
    const compare = item.querySelector('[data-wbi-cu-compare]');
    const badge = item.querySelector('[data-wbi-cu-badge]');
    const button = item.querySelector('[data-wbi-cu-add]');

    if (price) {
      price.textContent = option.dataset.price || price.textContent;
      price.classList.toggle('wbi-cu__price--on-sale', Boolean(option.dataset.compare));
    }
    if (compare) {
      const value = option.dataset.compare || '';
      compare.textContent = value;
      compare.hidden = value === '';
    }
    if (badge) {
      const discount = option.dataset.discount || '';
      badge.textContent = discount ? `-${discount}%` : '';
      badge.hidden = discount === '';
    }
    if (button) {
      button.dataset.wbiCuVariant = option.value;
      button.toggleAttribute('disabled', option.dataset.available !== 'true');
    }
  }

  const dispatchCartUpdate = (host, variantId, promise) => {
    const event = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
    event.action = 'add';
    event.context = 'cart';
    event.lines = [{ merchandiseId: variantId, quantity: 1 }];
    event.promise = promise;
    host.dispatchEvent(event);
  };

  async function addToCart(host, button) {
    if (button.hasAttribute('disabled')) return;

    const variantId = button.dataset.wbiCuVariant;
    if (!variantId) return;

    const slide = button.closest('.wbi-cu__slide');
    const error = slide?.querySelector('[data-wbi-cu-error]');

    if (error) error.textContent = '';
    button.setAttribute('disabled', '');
    button.dataset.state = 'loading';

    const sections = cartSectionIds();
    const body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (sections.length) body.sections = sections.join(',');

    let resolveUpdate;
    let rejectUpdate;
    const promise = new Promise((resolve, reject) => {
      resolveUpdate = resolve;
      rejectUpdate = reject;
    });
    promise.catch(() => {});

    dispatchCartUpdate(host, variantId, promise);

    try {
      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

      const payload = await response.json();
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || host.dataset.errorText);
      }

      resolveUpdate({
        cart: null,
        detail: { didError: false, sections: payload.sections, source: TAG },
      });

      button.dataset.state = 'added';
      announce(host, host.dataset.addedText);

      setTimeout(() => {
        if (button.isConnected) delete button.dataset.state;
      }, ADDED_MS);
    } catch (reason) {
      rejectUpdate(reason);
      delete button.dataset.state;

      const message = reason?.message || host.dataset.errorText;
      if (error) error.textContent = message;
      announce(host, message);
    } finally {
      if (button.isConnected) button.removeAttribute('disabled');
    }
  }

  document.addEventListener('click', (event) => {
    const nav = event.target.closest('[data-wbi-cu-prev], [data-wbi-cu-next]');
    if (nav) {
      const host = nav.closest(TAG);
      if (host) goTo(host, cursorOf(host) + (nav.hasAttribute('data-wbi-cu-prev') ? -1 : 1));
      return;
    }
    const button = event.target.closest('[data-wbi-cu-add]');
    if (button) {
      event.preventDefault();
      const host = button.closest(TAG);
      if (host) addToCart(host, button);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-wbi-cu-variants]');
    if (select) onVariantChange(select);
  });

  let touchX = 0;
  let touchY = 0;
  let touchHost = null;

  document.addEventListener(
    'touchstart',
    (event) => {
      const stage = event.target instanceof Element && event.target.closest('.wbi-cu--slider .wbi-cu__stage');
      touchHost = stage ? stage.closest(TAG) : null;
      if (!touchHost) return;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      if (!touchHost) return;
      const host = touchHost;
      touchHost = null;
      const dx = touchX - event.changedTouches[0].clientX;
      const dy = touchY - event.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_MIN) {
        const rtl = getComputedStyle(host).direction === 'rtl';
        const forward = rtl ? dx < 0 : dx > 0;
        goTo(host, cursorOf(host) + (forward ? 1 : -1));
      }
    },
    { passive: true }
  );

  function wheelNav(host, event) {
    const all = slides(host);
    if (all.length < 2) return;

    const delta = Math.abs(event.deltaX) >= Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
    if (Math.abs(delta) < 2) return;

    const target = cursorOf(host) + (delta > 0 ? 1 : -1);
    if (target < 0 || target >= all.length) return;

    event.preventDefault();
    const now = Date.now();
    if (now < (host.wbiWheelLock || 0)) return;
    host.wbiWheelLock = now + 320;
    goTo(host, target);
  }

  if (!customElements.get(TAG)) {
    customElements.define(
      TAG,
      class extends HTMLElement {
        connectedCallback() {
          if (!this.classList.contains('wbi-cu--slider')) return;
          const stage = this.querySelector('.wbi-cu__stage');
          if (!stage) return;
          this.wbiStage = stage;
          this.wbiWheel = (event) => wheelNav(this, event);
          stage.addEventListener('wheel', this.wbiWheel, { passive: false });
        }

        disconnectedCallback() {
          if (this.wbiStage && this.wbiWheel) {
            this.wbiStage.removeEventListener('wheel', this.wbiWheel);
          }
        }
      }
    );
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wbi-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
var W = window;
/* Cart state — one instance per page. */
if (!W.WBIShipBarStore) W.WBIShipBarStore = (() => {
  const subs = new Set();
  const RE = /\/cart\/(add|change|update|clear)(\.js|\b)/;
  let cart = null, sig = null, timer = 0, gifts = null, busy = false, ops = 0, seen = null;
  const base = () => (W.Shopify?.routes?.root || '/').replace(/\/+$/, '');
  const isCart = (u) => {
    if (!u) return false;
    let p = String(u);
    try { p = new URL(p, W.location.origin).pathname; } catch {}
    return RE.test(p);
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 250); };
  const refresh = () => fetch(base() + '/cart.js')
    .then((r) => (r.ok ? r.json() : null)).then((c) => c && emit(c)).catch(() => {});
  const qualifying = (c) => {
    let t = c.total_price;
    for (const it of c.items || []) if (it.properties?._wbi_gift) t -= it.final_line_price;
    return t < 0 ? 0 : t;
  };
  const emit = (c) => {
    cart = c;
    const s = c.total_price + ':' + c.item_count;
    if (s === sig) { busy = false; return; }
    sig = s;
    subs.forEach((fn) => { try { fn(c); } catch {} });
    syncGifts(c);
  };
  const post = (path, body) => fetch(base() + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).catch(() => { busy = false; });
  /* One mutation per cycle; the refresh re-enters with the gift line present
     so it cannot re-add. Adding the variant does NOT make it free — that still
     needs an automatic discount in Shopify. */
  const syncGifts = (c) => {
    busy = false;
    if (!gifts || !gifts.length || ops > 8) return;
    const t = qualifying(c);
    for (const g of gifts) {
      const line = (c.items || []).find((i) => String(i.properties?._wbi_gift) === String(g.t));
      const earned = t >= g.t * 100;
      if (earned === !!line) continue;
      busy = true; ops++;
      return earned
        ? post('/cart/add.js', { items: [{ id: Number(g.v), quantity: 1, properties: { _wbi_gift: String(g.t) } }] })
        : post('/cart/change.js', { id: line.key, quantity: 0 });
    }
  };
  const nf = W.fetch;
  if (typeof nf === 'function') W.fetch = function (input) {
    const u = typeof input === 'string' ? input : input?.url || '';
    const p = nf.apply(this, arguments);
    if (isCart(u)) p?.then?.(schedule, () => {});
    return p;
  };
  const XP = W.XMLHttpRequest?.prototype;
  if (XP && XP.open && XP.send) {
    const xo = XP.open, xs = XP.send;
    XP.open = function (m, u) { this.__wbiCart = isCart(u); return xo.apply(this, arguments); };
    XP.send = function () { if (this.__wbiCart) this.addEventListener('loadend', schedule); return xs.apply(this, arguments); };
  }
  /* Safety net. Horizon 4.x: shopify:cart:lines-update · Dawn 15.x: 'cart-update' */
  for (const e of ['shopify:cart:lines-update', 'cart:refresh', 'cart:updated'])
    document.addEventListener(e, schedule);
  const dawn = () => typeof W.subscribe === 'function' && (W.subscribe('cart-update', schedule), true);
  if (!dawn()) W.addEventListener('load', dawn, { once: true });
  W.addEventListener('pageshow', (e) => e.persisted && schedule());
  return {
    subscribe(fn) { subs.add(fn); if (cart) { try { fn(cart); } catch {} } return () => subs.delete(fn); },
    registerGifts(l) { if (!gifts && l && l.length) gifts = l; },
    qualifying,
    last: () => seen,
    keep: (v) => { seen = v; },
    refresh
  };
})();
const S = W.WBIShipBarStore, CE = W.customElements;
if (CE && !CE.get('wbi-shipping-bar')) CE.define('wbi-shipping-bar', class extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    const d = this.dataset;
    this.away = d.away || '';
    this.ok = d.success || '';
    this.cur = null;

    try { this.ms = JSON.parse(this.querySelector('.wbi-shipbar__data').textContent); } catch { this.ms = []; }
    if (!this.ms.length) return;
    this.ms.sort((a, b) => a.t - b.t);
    this.msgEl = this.querySelector('[data-wbi-msg]');
    this.nodeEls = {};
    for (const el of this.querySelectorAll('.wbi-shipbar__node')) this.nodeEls[el.dataset.i] = el;
    /* Re-place circles if the slots aren't in ascending order. */
    const n = this.ms.length;
    this.ms.forEach((m, j) => {
      const el = this.nodeEls[m.i];
      if (!el) return;
      el.style.setProperty('--wbi-pos', ((j + 1) / n) * 100 + '%');
      el.toggleAttribute('data-last', j === n - 1);
    });
    this._t = (parseInt(d.total, 10) || 0) / 100;
    if (d.gift === 'true') S.registerGifts(this.ms.filter((m) => m.k === 'free_gift' && m.v));
    this._off = S.subscribe(this.update.bind(this));
    this.seed();
  }

  disconnectedCallback() { this._off?.(); this._off = null; this._ready = false; }
  /* A drawer re-render hands us a new element that would snap to its final
     width. Replay the previous paint for one frame, then release. */
  seed() {
    const prev = S.last();
    const pct = parseFloat(this.style.getPropertyValue('--wbi-sb-progress')) || 0;
    const now = { p: pct, d: this.ms.map((m) => this._t >= m.t) };
    S.keep(now);
    if (!prev || prev.p === pct) return;
    const fresh = this.ms.map((m, j) => (!prev.d[j] && now.d[j] ? this.nodeEls[m.i] : null)).filter(Boolean);
    this.style.setProperty('--wbi-sb-progress', prev.p + '%');
    for (const el of fresh) el.classList.remove('is-done');
    void this.offsetWidth;
    requestAnimationFrame(() => {
      this.style.setProperty('--wbi-sb-progress', pct + '%');
      for (const el of fresh) this.unlock(el);
    });
  }

  unlock(el) {
    el.classList.add('is-done', 'is-new');
    el.addEventListener('animationend', () => el.classList.remove('is-new'), { once: true });
  }

  money(v) {
    const d = this.dataset;
    if (d.auto === 'true' && this.cur) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.cur }).format(v);
      } catch {}
    }
    const p = Math.abs(v).toFixed(d.dec == null ? 2 : +d.dec).split('.');
    const out = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, d.sep || '') + (p[1] ? '.' + p[1] : '');
    return d.pos === 'after' ? out + ' ' + d.sym : d.sym + ' ' + out;
  }
  /* Text nodes only — merchant copy is never parsed as HTML. */
  write(tpl, amount, reward) {
    const el = this.msgEl;
    if (!el) return;
    el.textContent = '';
    for (const part of String(tpl).split(/(\{\{\s*(?:amount|reward)\s*\}\})/g)) {
      if (!part) continue;
      const m = /^\{\{\s*(amount|reward)\s*\}\}$/.exec(part);
      if (!m) { el.appendChild(document.createTextNode(part)); continue; }
      const sp = document.createElement('span');
      sp.className = 'wbi-shipbar__' + m[1];
      sp.textContent = m[1] === 'amount' ? amount : reward;
      el.appendChild(sp);
    }
  }
  update(cart) {
    this.cur = cart.currency || null;
    const t = S.qualifying(cart) / 100;
    if (t === this._t) return;
    this._t = t;
    const ms = this.ms, n = ms.length;
    let passed = 0, prev = 0, next = null;
    for (const m of ms) {
      if (t >= m.t) { passed++; prev = m.t; } else if (!next) next = m;
    }
    let pct = 100;
    if (next) {
      const span = next.t - prev;
      pct = ((passed + (span > 0 ? (t - prev) / span : 0)) / n) * 100;
    }
    pct = Math.max(0, Math.min(100, pct));
    this.style.setProperty('--wbi-sb-progress', pct.toFixed(2) + '%');
    this.setAttribute('aria-valuenow', Math.round(pct));
    S.keep({ p: +pct.toFixed(2), d: ms.map((m) => t >= m.t) });
    for (const m of ms) {
      const el = this.nodeEls[m.i];
      if (!el) continue;
      const done = t >= m.t;
      if (el.classList.contains('is-done') === done) continue;
      const lab = el.querySelector('[data-wbi-label]');
      if (lab) lab.textContent = done && m.c ? m.c : m.l;
      if (done) this.unlock(el);
      else el.classList.remove('is-done');
    }
    this.write(next ? next.m || this.away : this.ok, next ? this.money(next.t - t) : '', next ? next.l : '');
  }
});
})();
  } catch(e) { console.error(e); }
})();

})();
